import {
    GET_REPORTDATA_REQUEST,
    GET_REPORTDATA_SUCCESS,
    GET_REPORTDATA_FAILURE,
    SET_SELECTED_USER,
    REMOVE_SELECTED_USER,
    GENERATE_DATA_REQUEST,
    GENERATE_DATA_SUCCESS,
    GENERATE_DATA_FAILURE,
    GET_AGGREGATE_OPTIONS_LIST_REPORT_REQUEST,
    GET_AGGREGATE_OPTIONS_LIST_REPORT_SUCCESS,
    GET_AGGREGATE_OPTIONS_LIST_REPORT_FAILURE,
    GET_VENTILATOR_LIST_REQUEST,
    GET_VENTILATOR_LIST_SUCCESS,
    GET_VENTILATOR_LIST_FAILURE,
    GET_REPORT_DOWNLOAD_DATA_REQUEST,
    GET_REPORT_DOWNLOAD_DATA_SUCCESS,
    GET_REPORT_DOWNLOAD_DATA_FAILURE
} from '../constants/';

const INIT_STATE = {
    isLoading: false,
    isGenerating: false,
    isInitialFetch: true,
    data: [],
    error: null,
    selectedUserId: null,
    reportTypeList: [],
    ventilatorList: [],
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_REPORTDATA_REQUEST:
            return {
                ...state,
                isLoading: true,
                selectedUserId: null,
                error: null,
            };
        case GET_REPORTDATA_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload.reportData,
                isInitialFetch: false,
            };
        case GET_REPORTDATA_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error.stack,
            };

        case SET_SELECTED_USER:
            return {
                ...state,
                selectedUserId: action.payload.userId,
                data: state.data.map((p) => {
                    if (p.id === action.payload.userId) {
                        return {
                            ...p,
                            isSelected: true
                        };
                    }
                    return {
                        ...p,
                        isSelected: false,
                    };
                }),
            };
        case REMOVE_SELECTED_USER:
            return {
                ...state,
                selectedUserId: null,
                data: state.data.map((p) => {
                    if (p.id === action.payload.userId) {
                        return {
                            ...p,
                            isSelected: false
                        };
                    }
                    return p;
                }),
            };
        case GENERATE_DATA_REQUEST:
            return {
                ...state,
                isGenerating: true,
            };
        case GENERATE_DATA_SUCCESS:
            return {
                ...state,
                isGenerating: false,
            };
        case GENERATE_DATA_FAILURE:
            return {
                ...state,
                isGenerating: false,
            };

        case GET_AGGREGATE_OPTIONS_LIST_REPORT_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case GET_AGGREGATE_OPTIONS_LIST_REPORT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                reportTypeList: action.payload.reportTypeList[0]?.items,
                isInitialFetch: false,
            };
        case GET_AGGREGATE_OPTIONS_LIST_REPORT_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error.stack,
            };
        case GET_VENTILATOR_LIST_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case GET_VENTILATOR_LIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                ventilatorList: action.payload.ventilatorList,
                isInitialFetch: false,
            };
        case GET_VENTILATOR_LIST_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error.stack,
            };
        case GET_REPORT_DOWNLOAD_DATA_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case GET_REPORT_DOWNLOAD_DATA_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isInitialFetch: false,
            };
        case GET_REPORT_DOWNLOAD_DATA_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error.stack,
            };
        default:
            return state;
    }
};